export const ACCEPT_OFFER_REQUEST = 'ACCEPT_OFFER_REQUEST';
export const ACCEPT_OFFER_SUCCESS = 'ACCEPT_OFFER_SUCCESS';
export const ACCEPT_OFFER_FAILURE = 'ACCEPT_OFFER_FAILURE';

export const DECLINE_OFFER_REQUEST = 'DECLINE_OFFER_REQUEST';
export const DECLINE_OFFER_SUCCESS = 'DECLINE_OFFER_SUCCESS';
export const DECLINE_OFFER_FAILURE = 'DECLINE_OFFER_FAILURE';
